import type { ReactNode } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { Fullscreen } from './Fullscreen';

const FullscreenContext = createContext({});

interface FullscreenProviderProps {
  isMobile: boolean;
  children?: ReactNode;
  popupWidth: string | number;
  imageRatio: number;
  enabled?: boolean;
}

export function FullscreenProvider({
  children,
  isMobile,
  enabled = false,
  ...props
}: FullscreenProviderProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPair, setSelectedPair] = useState<string | null>(null);

  const context = {
    isOpen,
    selectedPair,
    open: (id: string) => {
      setIsOpen(true);
      setSelectedPair(id);
    }
  };

  const handleCloseRequest = () => setIsOpen(false);

  useEffect(() => {
    if (enabled) {
      setIsOpen(false);
    }
  }, [enabled]);

  return (
    <FullscreenContext.Provider value={context}>
      {enabled && (
        <Fullscreen
          {...props}
          open={isOpen}
          isMobile={isMobile}
          selectedPair={selectedPair}
          onCloseRequest={handleCloseRequest}
        />
      )}

      {children}
    </FullscreenContext.Provider>
  );
}

export function useFullscreen() {
  return useContext(FullscreenContext);
}
